import { Calendar, ChevronRight } from "lucide-react";
import StatusBadge from "../Program/StatusBadge";
import PrioritasBadge from "../Program/PrioritasBadge";
import HighlightBadge from "./HighlightBadge";
import { HIGHLIGHT_STYLES, computeHighlight, formatDateShort } from "../../utils/progressUtils";

export default function SubListCard({ sub, selected, onSelect, assignmentRole }) {
  const h = computeHighlight(sub);
  const style = HIGHLIGHT_STYLES[h.level];

  return (
    <button
      type="button"
      onClick={() => onSelect(sub)}
      data-testid={`progress-sub-card-${sub.id}`}
      data-highlight={h.level}
      className={`w-full rounded-md bg-white p-3 text-left transition-all ${
        style.border
      } ${
        selected
          ? "border-[#1e3a5f] shadow-md ring-1 ring-[#1e3a5f]/30"
          : "border border-gray-200 hover:border-[#1e3a5f]/40 hover:shadow-sm"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 text-[10.5px] text-slate-500">
            <span className="font-mono">{sub.programKode} · {sub.id}</span>
            {sub.kategori ? (
              <span className="inline-flex h-4 items-center rounded bg-[#e8edf2] px-1 text-[9px] font-bold text-[#1e3a5f]">
                {sub.kategori}
              </span>
            ) : null}
            {assignmentRole ? (
              <span className="inline-flex items-center rounded bg-slate-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-slate-600">
                {assignmentRole === "KETUA_TIM"
                  ? "Ketua Tim"
                  : assignmentRole === "ANGGOTA_TIM"
                  ? "Anggota"
                  : "Dalnis"}
              </span>
            ) : null}
          </div>
          <div className="mt-0.5 line-clamp-2 text-[12.5px] font-medium text-slate-900">
            {sub.nama}
          </div>
          <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
            <StatusBadge status={sub.status} />
            <PrioritasBadge prioritas={sub.prioritas} />
            <HighlightBadge highlight={h} />
          </div>
          <div className="mt-2 flex items-center gap-1.5 text-[10.5px] text-slate-500">
            <Calendar className="h-3 w-3 text-slate-400" />
            <span>Deadline: {formatDateShort(sub.targetSelesai)}</span>
          </div>
          <div className="mt-1.5 flex items-center gap-2">
            <div className="h-1 w-full overflow-hidden rounded-full bg-gray-200">
              <div className="h-full bg-[#1e3a5f]" style={{ width: `${sub.progress || 0}%` }} />
            </div>
            <span className="text-[10.5px] font-semibold text-slate-600">
              {sub.progress || 0}%
            </span>
          </div>
        </div>
        <ChevronRight
          className={`h-4 w-4 shrink-0 mt-1 ${
            selected ? "text-[#1e3a5f]" : "text-gray-300"
          }`}
          strokeWidth={2}
        />
      </div>
    </button>
  );
}
